import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20cultural%20scene%2C%20ancient%20books%20and%20scrolls%20on%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20scholarly%20study%20room%2C%20elegant%20composition%2C%20rich%20cultural%20atmosphere%2C%20warm%20amber%20tones&width=1920&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          探索更多古典文化
        </h2>
        <p className="text-background-50/80 text-sm max-w-lg mx-auto mb-8 leading-relaxed">
          黄游下戟只是中国浩瀚典籍文化中的沧海一粟。加入我们，一起探寻更多被时光掩埋的文化瑰宝。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yuyi"
            className="px-8 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap"
          >
            阅读文章
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/40 hover:border-background-50 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}